exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".has-tags .button[data-v-45b4a375] {\n  margin-left: 0.3rem;\n  cursor: inherit;\n  text-decoration: none;\n}\n.has-tags .button[data-v-45b4a375]:hover {\n  opacity: 1;\n}\n@media (min-width: 768px) {\n.col-md-3[data-v-45b4a375] {\n    padding: 0 !important;\n}\n}\n.status-box[data-v-45b4a375] {\n  position: absolute;\n  top: 1em;\n  left: 1em;\n}\n.status-box .status[data-v-45b4a375], .status-box .status-new[data-v-45b4a375] {\n  position: static;\n  display: inline-block;\n  margin-right: 2px;\n}", ""]);

// exports
